let searchAll = function() {
	let t = this;
	t.inputFilter='';
	t.searchFilter()
};
export default searchAll;
